import styled, { css, keyframes } from "styled-components";

export const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10;
  left: 0;
  top: 0;
`;

export const Modal = styled.div`
  position: sticky;
  left: 50vw;
  top: 30vh;
  background-color: #fff;
  border-radius: 10px;
  width: fit-content;
  padding: 10px 20px;
  transform: translate(-50%);
  vertical-align: text-top;
`;

export const CloseDiv = styled.span`
  vertical-align: top;
`;